export default [
  {
    path: '/school',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/teacher',
    children: [
      {
        path: 'teacher',
        name: 'teacher',
        component: () => import('@/views/school/teacher/index.vue'),
        meta: {
          title: '学校管理/老师信息',
          keepAlive: true
        }
      },
      {
        path: 'teacher-detail/:id',
        name: 'teacher-detail',
        component: () => import('@/views/school/teacher/detail.vue'),
        meta: {
          title: '学校管理/老师详情',
          keepAlive: true
        }
      },
      {
        path: 'download',
        name: 'download',
        component: () => import('@/views/school/download/index.vue'),
        meta: {
          title: '学校管理/下载中心',
          keepAlive: true
        }
      },
      {
        path: 'manage',
        name: 'manage',
        component: () => import('@/views/school/manage/index.vue'),
        redirect: '/school/manage/detailTab',
        meta: {
          keepAlive: true
        },
        children: [{
          path: 'manageTab',
          name: 'manageTab',
          component: () => import('@/views/school/manage/manageTab/index.vue'),
          meta: {
            title: '学校管理/学校管理',
            keepAlive: true
          }
        }, {
          path: 'detailTab',
          name: 'detailTab',
          component: () => import('@/views/school/manage/detailTab/index.vue'),
          meta: {
            title: '学校管理/学校详情',
            keepAlive: true
          }
        }]
      },
      {
        path: 'course-package',
        name: 'course-package',
        redirect: '/school/course-package/consuption',
        component: () => import('@/views/school/course-package/index.vue'),
        meta: {
          title: '学校管理/课程包管理',
          keepAlive: true
        },
        children: [{
          path: 'consuption',
          name: 'consuption',
          component: () => import('@/views/school/course-package/modules/consuption/index.vue'),
          meta: {
            title: '学校管理/课程包管理/课程包消耗',
            keepAlive: true
          }
        }, {
          path: 'return',
          name: 'return',
          component: () => import('@/views/school/course-package/modules/return/index.vue'),
          meta: {
            title: '学校管理/课程包管理/返回申请',
            keepAlive: true
          }
        }]
      },
      {
        path: 'leads',
        name: 'leads',
        component: () => import('@/views/school/leads/index.vue'),
        meta: {
          title: '学校管理/Leads信息',
          keepAlive: true
        }
      },
      {
        path: 'leads-detail/:id',
        name: 'leads-detail',
        component: () => import('@/views/school/leads/detail.vue'),
        meta: {
          title: '学校管理/Leads详情',
          keepAlive: true
        }
      },
      {
        path: 'equipment',
        name: 'equipment',
        component: () => import('@/views/school/equipment/index.vue'),
        meta: {
          title: '学校管理/激活码管理',
          keepAlive: true
        }
      }
    ]
  }
]
